interface PageLoadErrorProps {
  title: string;
  onRetry: () => void;
  retrying?: boolean;
  body?: string;
}

/**
 * A required page request failed. Keep this separate from a true empty state:
 * an empty result is useful data, while a failed request must never look like
 * zero sales, no refunds, or a disconnected account.
 */
export function PageLoadError({
  title,
  onRetry,
  retrying = false,
  body = "Your saved data is safe. Try again.",
}: PageLoadErrorProps): React.ReactElement {
  return (
    <div
      role="alert"
      style={{
        maxWidth: 620,
        marginTop: 20,
        padding: "18px 20px",
        background: "color-mix(in srgb, var(--bad) 8%, var(--surface))",
        border: "1px solid color-mix(in srgb, var(--bad) 38%, var(--border))",
        borderRadius: "var(--r-card)",
        boxShadow: "var(--shadow-card)",
      }}
    >
      <h2 style={{ margin: 0, fontSize: 17 }}>{title}</h2>
      <p style={{ margin: "7px 0 0", color: "var(--body)", fontSize: 13.5, lineHeight: 1.5 }}>
        {body}
      </p>
      <button
        type="button"
        disabled={retrying}
        onClick={onRetry}
        style={{
          marginTop: 12,
          border: "1px solid var(--accent)",
          borderRadius: "var(--r-sm)",
          padding: "7px 13px",
          background: "var(--accent)",
          color: "var(--accent-contrast)",
          fontSize: 13,
          fontWeight: 700,
          cursor: retrying ? "default" : "pointer",
          opacity: retrying ? 0.6 : 1,
        }}
      >
        {retrying ? "Trying again…" : "Try again"}
      </button>
    </div>
  );
}
